import type { Mention } from '../types/chat';

/** Must match {@link ChatInput} group chat `ReactMention` markup prop. */
const GROUP_CHAT_MENTION_MARKUP = '@__[__display__](__id__)';

/** Collapse accidental `@@Name` (typed @ then picked from list) to `@Name`. */
export function collapseDuplicateAtSigns(plainText: string): string {
  return plainText.replace(/@@(?=[^\s@])/g, '@');
}

function mentionInsert(display: string, id: string): string {
  return GROUP_CHAT_MENTION_MARKUP.replace('__display__', display).replace('__id__', id);
}

/** True when value contains react-mentions markup (not plain text only). */
export function hasGroupChatMentionMarkup(value: string, plainText: string): boolean {
  return value !== plainText && /@__\[.+\]\([^)]+\)/.test(value);
}

/** Build react-mentions markup from plain text + parsed mention ranges (for highlighting). */
export function buildGroupChatMentionMarkup(plainText: string, mentions: Mention[]): string {
  if (!mentions.length) {
    return plainText;
  }

  let result = plainText;
  const sorted = [...mentions].sort((a, b) => b.start - a.start);

  for (const mention of sorted) {
    const display = mention.trigger.startsWith('@') ? mention.trigger.slice(1) : mention.trigger;
    const insert = mentionInsert(display, mention.userId);
    result = result.slice(0, mention.start) + insert + result.slice(mention.end);
  }

  return result;
}
